import type { WorkspaceRouter } from "replo-publisher/src/trpc/routers/workspace";

import { getNamespacedQueryClient } from "@v2/trpc/trpc";

import { createTrpcRouterConfig } from "../config";

const {
  router: workspaceRouter,
  client: workspaceClient,
  utils: workspaceUtils,
  options: workspaceOptions,
} = createTrpcRouterConfig<WorkspaceRouter>({
  path: "workspace",
  queryClient: getNamespacedQueryClient("workspace"),
});

export { workspaceClient, workspaceRouter, workspaceUtils, workspaceOptions };
